export default __webpack_public_path__ + "static/media/landing.f0ea17ec.png";